import { TypePropsCardSingle_lable } from './types/TypeSingleLable';
import { IoMdStar, IoMdStarHalf, IoMdStarOutline } from 'react-icons/io';
import { IoLocationSharp } from 'react-icons/io5';
import { formatName } from '@/constant/scripts';
import Link from 'next/link';
import Image from 'next/image';
import { Button } from '@/components/ui/button';

export default function CardSingle_lab(props: {
    DataProps: TypePropsCardSingle_lable;
}) {
    const { DataProps } = props;
    const fullStars = Math.floor(DataProps.rate);
    const halfStar = DataProps.rate % 1 !== 0;
    const emptyStars = 5 - fullStars - (halfStar ? 1 : 0);
    return (
        <Link
            target="_blank"
            prefetch={false}
            href={
                DataProps.type === 'lab'
                    ? `lab/${DataProps.id}/${formatName(DataProps.name)}`
                    : `/ImagingCenter/${DataProps.id}/${formatName(
                          DataProps.name,
                      )}`
            }
            className="transition-transform hover:-translate-y-1 p-4 relative flex flex-col justify-between shadow-btn shadow-sm rounded-xl w-full bg-white"
        >
            <div className="w-full">
                <Image
                    className="shadow-md mx-auto block rounded-full size-[110px]"
                    alt={`${
                        DataProps.type === 'imaging'
                            ? 'مرکز تصویر برداری'
                            : 'آزمایشگاه'
                    } : ${DataProps.name}`}
                    width={1000}
                    height={1000}
                    src={DataProps.pic}
                />

                <div>
                    <div className="justify-center mt-4 px-2 pt-3 border-t-2 w-full">
                        <p className="text-xl font-bold text-center pb-2">
                            {DataProps.name}
                        </p>
                        <p className="flex justify-center items-center">
                            {[...Array(fullStars)].map((_, index) => (
                                <IoMdStar
                                    key={`full-${index}`}
                                    className="text-md text-amber-500"
                                />
                            ))}
                            {halfStar && (
                                <IoMdStarHalf className="text-md text-amber-500" />
                            )}
                            {[...Array(emptyStars)].map((_, index) => (
                                <IoMdStarOutline
                                    key={`empty-${index}`}
                                    className="text-md text-gray-400"
                                />
                            ))}
                        </p>
                    </div>

                    <div className="flex_col gap-3 pb-4 smp:!pb-2 pt-2 max-h-[7rem]">
                        <div className="flex gap-1 self-start overflow-hidden text-ellipsis">
                            <p className="mt-[3px]">
                                <IoLocationSharp className=" text-base" />
                            </p>
                            <p className="text-base">{DataProps.address}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="w-full">
                <Button className="w-full bg-blue text-white !rounded-2xl relative z-50">
                    درخواست نوبت
                </Button>
            </div>
        </Link>
    );
}
